import { z } from 'zod'

export const feedQuerySchema = z.object({
  page: z.coerce.number().min(1).default(1),
  limit: z.coerce.number().min(1).max(50).default(20),
  type: z.enum(['all', 'clubs', 'posts']).default('all'),
})

export type FeedQueryInput = z.infer<typeof feedQuerySchema>
